import { render, staticRenderFns } from "./CellRendererCheckDelivery.vue?vue&type=template&id=2473948c&scoped=true"
import script from "./CellRendererCheckDelivery.vue?vue&type=script&lang=js"
export * from "./CellRendererCheckDelivery.vue?vue&type=script&lang=js"
import style0 from "./CellRendererCheckDelivery.vue?vue&type=style&index=0&id=2473948c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2473948c",
  null
  
)

export default component.exports